import 'babel-polyfill';
import Vue from 'vue';

import App from './App.vue';
import store from './store';
import router from './router';
import { localDataPermission } from '@iebdc/utils/local-data';
import Bus from './utils/bus.js';

Vue.use(Bus);

// 全局组件
import './components';
import '../../components';

// 插件
import './plugins/element.js';
// 样式
import './styles/index.scss';

// 自定义指令
import './directive';
import Slsm from './directive/slsm-dialog/slsm';
Vue.prototype.$slsm = Slsm.install;
import Qyrz from './directive/qyrz-dialog/qyrz';
Vue.prototype.$qyrz = Qyrz.install;
import Jbr from './directive/jbr-dialog/jbr';
Vue.prototype.$jbr = Jbr.install;

// 自定义过滤器
import * as filters from '../../filters';
import rules from '@/utils/validate.js';

//打印插件
import Print from '@iebdc/plugins/print'; // 引入附件的js文件
Vue.use(Print); // 注册
import { VueJsonp } from 'vue-jsonp';
Vue.use(VueJsonp);

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
Vue.prototype.rules = rules;
//全局-判断是否有权限
Vue.prototype.$hasPermission = (strPermission) => {
  if (String(strPermission) === 'true') return true;
  let allPermission = localDataPermission.get();
  if (!allPermission) return;
  if (allPermission.length > 0 && allPermission.indexOf(strPermission) > -1) {
    return true;
  } else {
    return false;
  }
};

Vue.prototype.$hasConstruction = (strConstruction) => {
  let allConstruction = localDataPermission.get();
  if (!allConstruction) return;
  if (allConstruction.length > 0 && allConstruction.indexOf(strConstruction) > -1) {
    return true;
  } else {
    return false;
  }
};

Vue.prototype.$store = store;
// mock 请求配置（如果需要就去掉注释）
// if (process.env.NODE_ENV === 'development') {
//   // mock 服务
//   require('./mock');
// }

Vue.config.productionTip = false;

// 清除 dupilcateNavigation的错误
import Router from 'vue-router';
// import dashboard from './router/modules/dashboard';

import { crypto } from '@iebdc/utils/crypto';

Vue.prototype.$encryptByDES = (strMessage, key) => {
  return crypto.encryptByDES(strMessage, key);
};
Vue.prototype.$decryptByDES = (strMessage, key) => {
  return crypto.decryptByDES(strMessage, key);
};

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
window.CONFIG.appKey = window.CONFIG.APP_IEBDC_KEY;
import Version from '@/utils/version';
Version.PrintVersionInfo();
new Vue({
  el: '#app',
  store,
  router,
  render: (h) => h(App),
});
